import { ENV } from "../app/interfaces/interfaces";

export const environment: ENV = {
  production: true,
  // apiUrl: 'https://todotix.gateway.test.todotix.net/',
  apiUrl: 'https://buses.gateway.test.todotix.net/',
  walletUrl: 'https://buses.vouchers.test.todotix.net/', //Test
  type: 'buses',
};
